import { createRouter, createWebHistory } from 'vue-router';
import UnderMaintenance from '@/UnderMaintenance.vue';
/*
import Theme586MainApp from '@/Theme586MainApp.vue';
import Theme586HomePage from '@/Theme586HomePage.vue';
import Theme586ProfilePage from '@/Theme586ProfilePage.vue';
import Theme586PostPage from '@/Theme586PostPage.vue';
import Theme586GalleryPage from '@/Theme586GalleryPage.vue';
import Theme586AboutPage from '@/Theme586AboutPage.vue';
import Theme586ContactPage from '@/Theme586ContactPage.vue';
import BlueCollarHomePage from '@/BlueCollarHomePage.vue'; 
*/
import Theme1HomePage from '@/Theme1HomePage.vue';

const router = createRouter({
  history: createWebHistory(), // Use HTML5 history mode
  routes: [
    {
      path: '/',
      name: 'index',
      component: UnderMaintenance,
    },
   /* {
      path: '/theme586',
      component: Theme586MainApp,
      children: [
        {
          path: '',
          name: 'Theme586HomePage',
          component: Theme586HomePage,
        },
        {
          path: 'gallery',
          name: 'gallery',
          component: Theme586GalleryPage,
        },
        {
          path: 'about',
          name: 'about',
          component: Theme586AboutPage,
        },
        {
          path: 'contact',
          name: 'contact',
          component: Theme586ContactPage,
        },
        {
          path: 'profile/:id',
          name: 'Theme586ProfilePage',
          component: Theme586ProfilePage,
          props: true, // This will pass the user ID as a prop
        },
        {
          path: 'post/a/:id',
          name: 'Theme586PostPage',
          component: Theme586PostPage,
          props: true, // This will pass the post ID as a prop
        },
      ],
    },
    {
      path: '/bluecollar',
      name: 'BlueCollarHomePage',
      component: BlueCollarHomePage,
    }, 
    */
    {
      path: '/theme1',
      name: 'Theme1HomePage',
      component: Theme1HomePage,
    },
  ],
});

export default router;
